import React from 'react';

export type QuadDataPoint = { displayName: string; value: string };

type QuadDataDisplayProps = {
  title: string;
  data: QuadDataPoint[];
};

export const QuadDataDisplay = ({ title, data }: QuadDataDisplayProps) => {
  return (
    <div className="text-center bg-white p-4 rounded-md">
      <h1 className="text-indigo-600 font-bold text-lg">{title}</h1>
      <hr className="border-slate-100 m-2 border" />
      <div className="grid grid-cols-2 gap-x-4 gap-y-2 mx-4">
        {data.map((point) => (
          <div
            key={point.displayName}
            className="flex flex-col justify-between border-2 border-slate-100 rounded-md py-1"
          >
            <p className="pt-1 mb-4 text-wrap">{point.displayName}</p>
            <p className="pb-1 font-bold">{point.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
